// @ts-ignore
import potrace from 'potrace';

// Function to convert an image file to an SVG string using potrace and clean up the viewBox and dimensions
export default function convertToSvg(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();

        // Handle the file load event
        reader.onload = () => {
            const result = reader.result;
            if (typeof result === 'string') {
                potrace.trace(result, (err: Error | null, svg: string) => {
                    if (err) {
                        reject(err);
                    } else {
                        // Clean up the SVG by adjusting the viewBox and setting dimensions
                        const cleanedSvg = adjustSvgViewBoxAndSize(svg);
                        resolve(cleanedSvg);
                    }
                });
            } else {
                reject(new Error('Failed to read the file as a string.'));
            }
        };

        // Handle file read errors
        reader.onerror = () => {
            reject(new Error('Error reading the file.'));
        };

        // Read the file as a data URL
        reader.readAsDataURL(file);
    });
}


function adjustSvgViewBoxAndSize(svg: string): string {

    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(svg, 'image/svg+xml');


    const svgElement = xmlDoc.querySelector('svg');
    const pathElement = xmlDoc.querySelector('path');

    if (svgElement && pathElement) {

        const tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        tempSvg.appendChild(pathElement.cloneNode(true));


        document.body.appendChild(tempSvg);


        const bbox = tempSvg.getBBox();


        const { x, y, width, height } = bbox;
        svgElement.setAttribute('viewBox', `${x} ${y} ${width} ${height}`);


        svgElement.setAttribute('width', `${width.toString()}px`);
        svgElement.setAttribute('height', height.toString());


        document.body.removeChild(tempSvg);
    }


    const serializer = new XMLSerializer();
    return serializer.serializeToString(xmlDoc);
}